<template>
    <h1>Agrolink content page</h1>
</template>

<script>
export default {
    name: "Content",
    data() {
        return {
            metaUrl: '/content',
        }
    }
}
</script>

<style scoped>

</style>
